(function ($) {
	$(function () {
		$(".slider").addClass("swiper");
		$(".slider > ul").addClass("swiper-wrapper");
		$(".slider > ul > li").addClass("swiper-slide");

		let swiper	=	new Swiper(".slider", {
			speed				:	8000,
			slidesPerView		:	"auto",
			loop				:	true,
			freeMode			:	true,
			freeModeMomentum	:	false,
			slidesPerView		:	2,
			autoplay: {
				delay					:	0,
				disableOnInteraction	:	false,
			},
			breakpoints: {
				969	:	{
						slidesPerView: 5,
				}
			}
		});

		$(".opener .headline").on("click", function () {
			let $target	=	$(this);

			$target.next(".explain").stop().slideToggle(function () {
			});
		});
	});
})(jQuery);